import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./views/Home/Home";
import Imprint from "./views/Imprint/Imprint";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/imprint" element={<Imprint />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;